export const SEARCH_SUGGESTIONS_FLAG = 'show_search_suggestions_banner'
export const BREAST_PUMP_BANNER_NAME = 'breast-pump'
export const FREE_GIFT_FLAG = 'is_free_gift_enabled'
